const settings = {
  BASE_URL: '',
  API_URL: '',
  SOCKET_URL: '',
  mfa_redirect: false,
};

switch (process.env.REACT_APP_GOAL) {
  case 'production': {
    settings.BASE_URL = `https://api-prod-ma.vegasimulator.com`;
    settings.API_URL = `https://api-prod-ma.vegasimulator.com/api`;
    settings.SOCKET_URL = `wss://api-prod-ma.vegasimulator.com/api`;
    break;
  }
  case 'stage': {
    settings.BASE_URL = `https://api-stage-ma.vegasimulator.com`;
    settings.API_URL = `https://api-stage-ma.vegasimulator.com/api`;
    settings.SOCKET_URL = `wss://api-stage-ma.vegasimulator.com/api`;
    break;
  }
  default: {
    settings.BASE_URL = 'http://localhost:8001';
    settings.API_URL = `http://localhost:8001/api`;
    settings.SOCKET_URL = `ws://localhost:8001/api`;
    settings.mfa_redirect = false;
  }
}

export default settings;
